import React from "react"
import { getDaysInMonth, isDateInRange, isDateSelected } from "../../utils/date/calendar"
import { ddmmyyyyformatDate } from "../../utils/date/format"
import { CALENDAR_FLEX_MODE } from "../../utils/variables/calendar"
import { motion } from "framer-motion"
import { cn } from "../../../lib"

const Grid = ({
  date,
  availableDepart,
  availableRetur,
  highlightedDates,
  handleFlexClick,
  handleFlexMouseEnter,
  handleDay,
  priceData = {},
  isDeparture,
  selectedDates,
  mode,
  isSelecting,
  changeMonth,
  dragStartDate,
  currencySymbol,
}) => {
  const { daysInMonth, startingDayOfWeek } = getDaysInMonth(date)
  const monthKey = `${date.getFullYear()}-${date.getMonth() + 1}`
  const highlighted = highlightedDates[monthKey] || []
  const days = []

  for (let day = 1; day <= daysInMonth; day++) {
    const index = startingDayOfWeek + day - 1
    const dayString = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(day).padStart(2, "0")}`

    const isAvailable = isDeparture
      ? availableDepart.includes(dayString)
      : availableRetur.includes(dayString)

    const minPrice = priceData[dayString]
    const hasPrice = isAvailable && minPrice != null

    const isSelected = isDateSelected(day, date, selectedDates)
    const isInRange = isDateInRange(day, date, selectedDates, mode)

    const dates = Array.isArray(selectedDates) ? selectedDates : []
    const sortedDates = [...dates].sort((a, b) => {
      const parse = (s) => {
        const [d, m, y] = s.split(".").map(Number)
        return new Date(y, m - 1, d)
      }
      return parse(a) - parse(b)
    })

    const isFirstDate = dates.length > 1 && ddmmyyyyformatDate(day, date) === sortedDates[0]
    const isLastDate =
      dates.length > 1 && ddmmyyyyformatDate(day, date) === sortedDates[sortedDates.length - 1]
    const isBoundaryDate = isFirstDate || isLastDate
    const isDragStart =
      isSelecting && isDeparture && ddmmyyyyformatDate(day, date) === dragStartDate

    const isActiveSelected =
      (isBoundaryDate && isSelected) ||
      (isSelected && !isInRange && !isBoundaryDate && dates.length === 1)

    days.push(
      <motion.div
        key={`day-${day}-${index}`}
        onMouseEnter={() =>
          isDeparture && mode === CALENDAR_FLEX_MODE && handleFlexMouseEnter(day, date)
        }
        onClick={() => handleDay(day, date)}
        className={cn(
          "relative w-full flex flex-col items-center justify-center py-1 rounded-md cursor-pointer transition-colors duration-200 select-none",
          hasPrice ? "min-h-[48px]" : "min-h-[36px]",
          isActiveSelected && "bg-app-base-strong text-white",
          isInRange && !isBoundaryDate && "bg-app-base-strong/20",
          !isActiveSelected && !isInRange && isAvailable && "bg-green-500",
          isDragStart && "ring-2 ring-app-base-strong"
        )}
        initial={{ opacity: 0, scale: 0.85 }}
        animate={{ opacity: 1, scale: 1 }}
        whileHover={isAvailable || isActiveSelected ? { scale: 1.06 } : {}}
        whileTap={isAvailable || isActiveSelected ? { scale: 0.95 } : {}}
        transition={{ duration: 0.18, delay: index * 0.008, type: "spring", stiffness: 320 }}
      >
        {/* число */}
        <span
          className={cn(
            "text-sm font-medium leading-none",
            isActiveSelected && "text-white",
            !isActiveSelected && isAvailable && "text-white",
            !isActiveSelected && !isAvailable && "text-gray-700 dark:text-gray-300"
          )}
        >
          {day}
        </span>

        {/* цена или спейсер */}
        {hasPrice ? (
          <span
            className={cn(
              "text-[10px] leading-none font-semibold mt-1 tabular-nums",
              isActiveSelected ? "text-white/90" : "text-white"
            )}
          >
            {Math.round(minPrice)}
            {currencySymbol}
          </span>
        ) : (
          <span className="text-[10px] leading-none mt-1 opacity-0 select-none" aria-hidden>
            0
          </span>
        )}
      </motion.div>
    )
  }

  return <div className="grid grid-cols-7 gap-1">{days}</div>
}

export default Grid
